import { render, staticRenderFns } from "./create-entity.vue?vue&type=template&id=e39533b6&scoped=true"
import script from "./create-entity.vue?vue&type=script&lang=ts"
export * from "./create-entity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e39533b6",
  null
  
)

export default component.exports